import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useState } from 'react';
import Review from '../supplierPoGrn/Review';
import axios from 'axios';
import { appUrl } from '../../../../../utils/config';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: '#F9F9FC',
  },
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    backgroundColor: '#F5F9FF',
  },
  head: {
    textAlign: 'center',
  },
  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '12px',
    right: '10px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: '#FF0000',
    },
  },
  stepIcon: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E0E0E0',
    color: '#fff',
  },
  active: {
    backgroundColor: '#EC6535', // orange when active
  },
  completed: {
    backgroundColor: '#4CAF50', // green when completed
  },
  number: {
    color: '#fff',
    fontWeight: '550',
  },
  stepConnector: {
    '& $line': {
      borderColor: '#E0E0E0',
    },
  },
  completedStepConnector: {
    '& $line': {
      borderColor: '#4CAF50',
    },
  },
  line: {
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const ResolveQA = ({
  openDialog,
  closeViewScreen,
  POLineRecordDetails,
  row,
}) => {
  const [loading, setLoading] = useState(true);
  const [poDetails, setPoDetails] = useState({});
  const [qaInfoData, setQaInfoData] = useState({});
  const [OtherInfoTempNumber, setOtherInfoTempNumber] = useState(0);
  const [errors, setErrors] = useState({
    qaQuantityFields: '',
    cmoQADate: '',
    errorTitle: '',
    coaFile: '',
  });
  const classes = useStyles();

  const handleCancel = () => {
    closeViewScreen();
  };

  useEffect(() => {
    const data = {
      supplierPurchaseOrderNumber:
        POLineRecordDetails.supplierPurchaseOrderNumber,
      materialCode: POLineRecordDetails.materialCode,
      schrockenSupplierPOBatchID: row.schrockenSupplierPOBatchID,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchGRNLineDetails`,
        data
      )
      .then((res) => {
        setPoDetails(res.data.data.PODetails);
        setQaInfoData({
          ...res.data.data.PODetails.GRDetails.qualityAssuranceInfo,
          // samplingMaterialNumberQA:
          //   String(res.data.data.PODetails.POLineRecordDetails.materialCode) ||
          //   '',
          analyticalReportNumber:
            res.data.data.PODetails.GRDetails.qualityAssuranceInfo
              .analyticalReportNumber || '',
          samplingQuantityQA:
            res.data.data.PODetails.GRDetails.qualityAssuranceInfo
              .samplingQuantityQA || 0.0,
          passedQtyQA:
            res.data.data?.PODetails?.GRDetails?.qualityAssuranceInfo
              ?.passedQtyQA || 0.0,
          rejectedQuantityQA:
            res.data.data?.PODetails?.GRDetails?.qualityAssuranceInfo
              ?.rejectedQuantityQA || 0.0,
          cmoQADate:
            res.data.data?.PODetails?.GRDetails?.qualityAssuranceInfo
              ?.cmoQADate || '',
          reasonForRejection: '',
          // otherInformation: '',
        });
        // setCOAFILES()
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handlingDeleteFile = (i) => {
    if (qaInfoData.COAFiles[i].grFileType === 'buffer') {
      let newdel = qaInfoData.COAFiles.filter(
        (file) => file.grFileName !== qaInfoData.COAFiles[i].grFileName
      );
      setQaInfoData((previousData) => ({ ...previousData, COAFiles: newdel }));
      // setCOAFILES(newdel);
    } else {
      // COAFiles[i].markForDelete=1;
      let markDelFile = qaInfoData.COAFiles.map((file) =>
        file.grFileHash === qaInfoData.COAFiles[i].grFileHash
          ? { ...file, markForDelete: true }
          : file
      );
      setQaInfoData((previousData) => ({
        ...previousData,
        COAFiles: markDelFile,
      }));
      // setCOAFILES(markDelFile);
    }
  };

  const fileHandling = (files, Type) => {
    files.forEach((file) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const newArr = {
          grFileData: reader.result,
          grFileName: file.name,
          grFileType: 'buffer',
          schrockenGRFileId: '',
          grFileHash: '',
          markForDelete: false,
        };

        // setCOAFILES([...COAFiles, newArr]);
        setQaInfoData((previousData) => ({
          ...previousData,
          COAFiles: [...previousData.COAFiles, newArr],
        }));
        // handlingFiles(newArr, 'COAFiles');
      };
    });
  };

  const handleValidation = (data) => {
    let valid = true;
    // if (
    //   qaInfoData.samplingQuantityQA &&
    //   parseFloat(qaInfoData.samplingQuantityQA) === 0
    // ) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     samplingQuantityQA: 'Enter QA Sampling Quantity',
    //   }));
    // }
    // if (
    //   qaInfoData.passedQtyQA &&
    //   parseFloat(qaInfoData.passedQtyQA) === 0
    // ) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     passedQtyQA: 'Enter QA Passes Quantity',
    //   }));
    // }
    // if (
    //   qaInfoData.rejectedQuantityQA &&
    //   parseFloat(qaInfoData.rejectedQuantityQA) === 0
    // ) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     passedQtyQA: 'Enter QA Rejected Quantity',
    //   }));
    // }

    if (!data.analyticalReportNumber) {
      valid = false;
      setErrors((previousData) => ({
        ...previousData,
        analyticalReportNumber: 'Enter Analytical Report Number.',
        errorTitle: 'Enter the Analytical Report Number.',
      }));
      return valid;
    }

    if (!data.cmoQADate) {
      valid = false;
      setErrors((previousData) => ({
        ...previousData,
        cmoQADate: 'Enter CMO QA Date.',
        errorTitle: 'Enter the QA Date.',
      }));
      return valid;
    }

    const isEqual3Decimals = (a, b) =>
      Math.round(a * 1000) === Math.round(b * 1000);

    let sum =
      parseFloat(data.samplingQuantityQA) +
      parseFloat(data.passedQtyQA) +
      parseFloat(data.rejectedQuantityQA);
    if (
      !isEqual3Decimals(
        sum,
        parseFloat(
          poDetails.GRDetails.receivedQuantityInfo.actualQuantityReceived
        )
      )
      // sum !==
      // parseFloat(
      //   poDetails.GRDetails.receivedQuantityInfo.actualQuantityReceived
      // )
    ) {
      valid = false;
      setErrors((previousData) => ({
        ...previousData,
        qaQuantityFields: 'Enter correct quantity.',
        errorTitle:
          'Quantity discrepancy detected. The sum of the sampled, passed, and rejected quantity must equal the total quantity. Please revise the quantities and try again.',
      }));
      return valid;
    }

    // if (Array.isArray(data.COAFiles) && data.COAFiles.length < 1) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     coaFile: 'Upload CoA file.',
    //     errorTitle: 'Missing CoA file.',
    //   }));
    //   return valid;
    // }

    setErrors((previousData) => ({
      ...previousData,
      coaFile: '',
      errorTitle: '',
      cmoQADate: '',
      qaQuantityFields: '',
    }));

    return valid;
  };

  return (
    <>
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: '0px' }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant='h6' style={{ fontSize: '1.875rem' }}>
                  Update Material Details
                </Typography>
                <Typography>
                  Raw Material (RM) / Packaging Material (PM) Record
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant='body2'
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{' '}
                <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ paddingBottom: '2rem' }}>
          <Grid container justifyContent='center'>
            <Grid item xs={12} md={10}>
              {!loading ? (
                <Review
                  status={
                    poDetails.GRDetails.POBatchRecordDetails.batchStatusID
                  }
                  poDetails={poDetails}
                  qaInfoData={qaInfoData}
                  onClose={handleCancel}
                  COAFiles={qaInfoData?.COAFiles ? qaInfoData?.COAFiles : []}
                  fileHandling={fileHandling}
                  handlingDeleteFile={handlingDeleteFile}
                  tempNumber={OtherInfoTempNumber}
                  handleValidation={handleValidation}
                  errors={errors}
                  setErrors={setErrors}
                />
              ) : (
                <Grid container justify='center'>
                  <div
                    style={{
                      textAlign: 'center',
                      marginTop: '15%',
                      minWidth: '60vw',
                    }}
                  >
                    <CircularProgress color='primary' thickness={7} />
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ResolveQA;
